// Copyright (c) 2017 Deere & Company

const hoursUnitExists = allowedUnits =>
    allowedUnits.some(item => item.key === 'H');

/* eslint-disable complexity */

export const getUnitKey = product => {

    let unitKey;

    if (product.useAmountAllowedUnits.length === 1) {

        unitKey = product.useAmountAllowedUnits[0].key;

    } else if (product.useAmount.amount.length && product.useAmountAllowedUnits.length > 1) {

        unitKey = product.useAmount.unit.key;

    } else if (!product.useAmount.amount.length && hoursUnitExists(product.useAmountAllowedUnits)) {

        unitKey = 'H';

    } else {

        unitKey = product.useAmountAllowedUnits[0].key;

    }

    return unitKey ? unitKey : '';

};

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/claim/shared/services/get-unit-key.js